// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1HsvS","select":"Header_select__twXCZ","clinic":"Header_clinic__5VoNV"};